import { render, staticRenderFns } from "./visual_memory.config.vue?vue&type=template&id=eeb355c8"
import script from "./visual_memory.config.vue?vue&type=script&lang=js"
export * from "./visual_memory.config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports